import { defineStore } from "pinia";

export const useCounterStore = defineStore("counter", {
  state: () => ({
    counters: [] as { name: string; count: number }[]
  }),

  actions: {
    increment(name: string): number {
      this.counters.every((counter: { name: string; count: number }) => {
        if (counter.name === name) {
          return ++counter.count;
        }
      });

      // Not found - insert with default 1
      this.counters.push({ name, count: 1 });
      return 1;
    },

    decrement(name: string): number {
      this.counters.every((counter: { name: string; count: number }) => {
        if (counter.name === name) {
          counter.count = Math.max(0, counter.count - 1);
          return counter.count;
        }
      });

      // Not found - insert with default 0
      this.counters.push({ name, count: 0 });
      return 0;
    },

    count(name: string): number {
      this.counters.every((counter: { name: string; count: number }) => {
        if (counter.name === name) {
          return counter.count;
        }
      });

      // Not found - return default 0
      return 0;
    }
  }
});
